export default __webpack_public_path__ + "static/media/auth-bg.e1092242.png";